/**
 * `localStorage` key builders for the Health Tracker cache.
 *
 * Every health-cache key is derived from the customer id so that one
 * customer's cached data can never collide with or leak into another's.
 *
 * Satisfies:
 * - Requirement 1.1: cached health data is keyed and retrievable per customer.
 * - Requirement 14.1: per-customer isolation — every key is derived from the
 *   customer id.
 */

/** Key for a customer's cached health records (merged, deduped list). */
export const HEALTH_RECORDS_KEY = (customerId: string): string =>
  `ht_records_cache_${customerId}`;

/** Key for a customer's cached snapshot (profile, notes, recent vitals). */
export const HEALTH_SNAPSHOT_KEY = (customerId: string): string =>
  `ht_snapshot_cache_${customerId}`;

/** Key for the current-month report cache, keyed by request URL. */
export const REPORT_CURRENT_MONTH_KEY = (url: string): string =>
  `ht_report_current_${url}`;

/** Key for the report prompt dismissal timestamp, scoped by customer ID. */
export const REPORT_PROMPT_DISMISS_KEY = (customerId: string): string =>
  `ht_report_prompt_dismissed_${customerId}`;

/** Single FIFO list holding past-month report entries across customers. */
export const REPORT_LIST_KEY = 'ht_report_list';
